import { axios } from '@/utils/request'

// 查询用户列表
export function getUserList(params) {
  return axios({
    url: '/users',
    method: 'get',
    params: params
  })
}

//设置用户是否异常
export function setUserAbnormal(id){
  return axios({
    url:`/user/${id}/abnormal`,
    method:'post',
  })
}

// 添加用户
export function addUser(params) {
  return axios({
    url: '/users',
    method: 'post',
    data: params
  })
}

// 查询用户信息
export function getUser(user_id) {
  return axios({
    url: `/users/${user_id}`,
    method: 'get'
  })
}

// 修改用户信息
export function updateUser(user_id, params) {
  return axios({
    url: `/users/${user_id}`,
    method: 'put',
    data: params
  })
}

// 删除用户
export function deleteUser(user_id) {
  return axios({
    url: `/users/${user_id}`,
    method: 'delete'
  })
}

// 修改密码
export function modifyPassword(params){
  return axios({
    url: '/users/modify_password',
    method: 'put',
    data: params
  })
}

//查询娃娃数量变化
export function getUserRecordList(params) {
  return axios({
    url: '/user/recharge/record',
    method: 'get',
    params: params
  })
}

//查询娃娃赞助记录
export function getUserSponsorList(params) {
  return axios({
    url: '/sponsor',
    method: 'get',
    params: params
  })
}

// 以下为新增的接口----------
// 导出用户列表
export function exportUserList(params){
  return axios({
    url:'/users/excel',
    method:'get',
    params
  })
}
//
export function getUserDetailList(params) {
  return axios({
    url: `/user/${params.id}/order`,
    method: 'get',
    params: params
  })
}

//获取用户游戏币操作记录
export function getUserGameCoinRecords(params){
  return axios({
    url:`/game_coin/${params.id}/record`,
    method:"get",
    params:params
  })
}
// 导出充值明细
export function exportUserRecordList(params){
  return axios({
    url:'url',
    method:'get',
    params
  })
}
//根据uid查询用户信息
export function queryUserInfo(params){
  return axios({
    url:`/user/info/${params.uid}`,
    method:'get',
    params
  })
}
// 对用户进行充值
export function rechargeUser(params){
  return axios({
    url:'/user/recharge',
    method:'post',
    data:params
  })
}
//存币
export function addGameCoinApi(uid, quantity) {
  return axios({
    url: '/game_coin/add',
    method: 'POST',
    data: {
      uid,
      quantity
    }
  })
}
//扣币
export function withdrawalGameCoin(uid,quantity){
  return axios({
    url: `/game_coin/withdrawal`,
    method: 'POST',
    data:{
      uid,
      quantity
    }
  })
}
